module.exports = __webpack_public_path__ + "img/df361b2.png";